import { ROLES } from '../constants/preset-constants';
import EnrolmentCategoryField from '../models/EnrolmentCategoryField';

export function isFieldSupported(columnId: number, supportedFields: EnrolmentCategoryField[]) {
    let supported = false;
    supportedFields.find((field, i) => {
        if (field.columnId === columnId) {
            return true;
        }
        return false;
    });

    return supportedFields.length > 0;
}

/**
 * 
 * @param profileId - User role id SYSTEM_OWNER, SITE_ADMIN, SITE_INSTALLER, etc
 * @param tagCode - card number
 * @returns String value which will be a - not non-access transaction (alarm, status), actual tag code is 
            logged in user is either system owner or site admin, otherwise hide tag code by return asterisk   
 */
export const showTagCode = (profileId: number, tagCode: string | undefined): string => {
    if (!tagCode) {
        return "-"
    }
    else if (profileId === ROLES.ID_SYSTEM_OWNER || profileId === ROLES.ID_SITE_ADMIN) {
        return tagCode;
    }

    return '*********';
}